import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingDown, Activity, RefreshCw } from "lucide-react";

export default function FunnelMetricsWidget() {
  const [data, setData] = useState(null);
  const [days, setDays] = useState(30);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get("/messaging/admin/funnel-metrics", { params: { days, environment: "production" } });
      setData(r.data);
    } finally { setLoading(false); }
  }, [days]);

  useEffect(() => { load(); }, [load]);

  const steps = data?.steps || [];
  const maxCount = Math.max(1, ...steps.map(s => s.count || 0));

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="funnel-metrics-widget">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 font-bold text-[#0B2B62]">
          <Activity className="w-4 h-4"/> Funil de Conversão (LIA → Matrícula)
        </div>
        <div className="flex items-center gap-2">
          <select value={days} onChange={e=>setDays(Number(e.target.value))} className="border rounded-lg px-2 py-1 text-xs" data-testid="funnel-days-select">
            <option value={7}>7 dias</option>
            <option value={30}>30 dias</option>
            <option value={90}>90 dias</option>
          </select>
          <button onClick={load} disabled={loading} className="p-1 hover:bg-slate-100 rounded" data-testid="funnel-refresh"><RefreshCw className={`w-3.5 h-3.5 ${loading?"animate-spin":""}`}/></button>
        </div>
      </div>
      {!data && <div className="text-xs text-slate-400 py-8 text-center">Carregando funil...</div>}
      {data && (
        <div className="space-y-2">
          {steps.map((s, i) => {
            const pct = Math.max(3, (100 * (s.count||0) / maxCount));
            const dropPrev = s.drop_from_prev ?? 0;
            return (
              <div key={s.key} className="group" data-testid={`funnel-step-${s.key}`}>
                <div className="flex items-center justify-between text-xs mb-0.5">
                  <div className="text-slate-600 font-medium">{s.label}</div>
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-[#0B2B62]" data-testid={`funnel-count-${s.key}`}>{s.count}</span>
                    <span className="text-[10px] text-slate-400">({s.rate_from_start}% do início)</span>
                  </div>
                </div>
                <div className="h-6 rounded-lg bg-slate-50 overflow-hidden relative">
                  <div className="h-full bg-gradient-to-r from-violet-400 to-violet-600 flex items-center justify-end pr-2" style={{ width: `${pct}%` }}>
                    {s.count > 0 && <span className="text-[10px] text-white font-semibold">{s.count}</span>}
                  </div>
                </div>
                {i > 0 && dropPrev > 0 && (
                  <div className="text-[10px] text-red-500 mt-0.5 flex items-center gap-1">
                    <TrendingDown className="w-3 h-3"/> queda de {dropPrev}% em relação à etapa anterior
                  </div>
                )}
              </div>
            );
          })}
          {data.urgent_conversations > 0 && (
            <div className="mt-3 text-xs rounded-lg bg-red-50 border border-red-200 text-red-700 px-3 py-2">
              <b>{data.urgent_conversations}</b> conversas marcadas como prioridade humana no período.
            </div>
          )}
          <div className="mt-2 text-[10px] text-slate-400">Canais: {Object.entries(data.channels||{}).map(([k,v])=>`${k}: ${v}`).join(" · ")}</div>
        </div>
      )}
    </div>
  );
}
